/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Faster_LabelInputs */

const en_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seconds to tailor`)
};

const de_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekunden zur Anpassung`)
};

const fr_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondes pour adapter`)
};

const es_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundos para adaptar`)
};

const it_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondi per adattare`)
};

const nl_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seconden om aan te passen`)
};

const pl_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekund na dostosowanie`)
};

const fi_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekuntia räätälöintiin`)
};

const da_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekunder til tilpasning`)
};

const sv_landing_stat_faster_label = /** @type {(inputs: Landing_Stat_Faster_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekunder att anpassa`)
};

/**
* | output |
* | --- |
* | "Seconds to tailor" |
*
* @param {Landing_Stat_Faster_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_faster_label = /** @type {((inputs?: Landing_Stat_Faster_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Faster_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_faster_label(inputs)
	if (locale === "fr") return fr_landing_stat_faster_label(inputs)
	if (locale === "es") return es_landing_stat_faster_label(inputs)
	if (locale === "it") return it_landing_stat_faster_label(inputs)
	if (locale === "nl") return nl_landing_stat_faster_label(inputs)
	if (locale === "pl") return pl_landing_stat_faster_label(inputs)
	if (locale === "fi") return fi_landing_stat_faster_label(inputs)
	if (locale === "da") return da_landing_stat_faster_label(inputs)
	if (locale === "sv") return sv_landing_stat_faster_label(inputs)
	return en_landing_stat_faster_label(inputs)
});